import React from "react";
import { Box } from "@mui/material";

const PageContainer = ({ children, maxWidth = 1400, noPadding = false }) => {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        minHeight: "calc(100vh - 140px)",
        p: noPadding ? 0 : { xs: 1, sm: 3 },
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ width: "100%", maxWidth, mx: "auto", overflowX: "hidden" }}>{children}</Box>
    </Box>
  );
};

export default PageContainer;
